import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs';
import { SplHttpAuthService } from '@splitory/splitory-http';

export const authOnlyGuard: CanActivateFn = () => {
  const authService = inject(SplHttpAuthService);
  const router = inject(Router);

  return authService.authStateLoading$.pipe(
    filter((loading) => !loading),
    switchMap(() => authService.authState$),
    map((authState) => {
      return !!authState || router.createUrlTree(['/auth']);
    }),
  );
};
